export default __webpack_public_path__ + "static/alpine-meridian-logo-cd58034c698ab205bb7a3effad0f7fde.png";